import { verdictColor } from "./DegenScore";

const utcTime = (ts) => {
  const d = ts ? new Date(ts * 1000) : new Date();
  return `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")} UTC`;
};

// Plain-English, factual summary of the token report (idea 3). Deterministic — the
// sharp editorial voice lives in the Autopsy/editorial features, not here.
export const TokenSummary = ({ coin, rug }) => {
  const s = coin.score;
  const max = s.maxPossible || 100;
  const sym = `$${(coin.symbol || "").replace("$", "")}`;

  const parts = [];
  parts.push(`${sym} scores ${s.total}/${max} — ${s.verdict}.`);

  if (rug && rug.available) {
    if (rug.topHolderPct != null) {
      const conc = rug.top10Pct != null ? `, and the top 10 hold ${rug.top10Pct}%` : "";
      parts.push(`The largest wallet controls ${rug.topHolderPct}% of supply${conc}.`);
    }
    parts.push(rug.lpLocked
      ? "Liquidity is locked or burned, so the dev can't pull it."
      : rug.lpUnlocked
        ? "Liquidity is NOT locked — a rug vector to weigh."
        : `LP lock status is unverified (${rug.lpLockedPct || 0}% locked).`);
    parts.push(rug.mintRevoked
      ? "Mint authority is revoked (supply can't be inflated)."
      : "Mint authority is still active — the dev can mint more supply.");
    if (!rug.freezeRevoked) parts.push("Freeze authority is still active — accounts could be frozen.");
  } else {
    parts.push("On-chain safety (authorities, LP lock and holder concentration) is unverified — the score is capped until it can be confirmed.");
  }

  return (
    <div className="border border-white/10 bg-card p-5" data-testid="token-summary">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-heading font-bold text-lg">The Read</h2>
        <span className="font-mono text-[10px] px-2 py-0.5 border shrink-0" style={{ color: verdictColor(s.verdict), borderColor: verdictColor(s.verdict) + "40" }}>{s.verdict}</span>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">{parts.join(" ")}</p>
      <p className="text-[10px] text-muted-foreground/60 font-mono mt-3">Data observed {utcTime(s.scoredAt)} · signals & evidence, not a verdict — DYOR.</p>
    </div>
  );
};
